export default __webpack_public_path__ + "static/demo-splash-873479e5aae634a78ef528bb45181d26.png";